<div class="image-caption markdown-container" [innerHTML]="markdown"></div>
